"use strict";
// THIS FILE IS AUTO-GENERATED BY FIGMAGIC. DO NOT MAKE EDITS IN THIS FILE! CHANGES WILL GET OVER-WRITTEN BY ANY FURTHER PROCESSING.
Object.defineProperty(exports, "__esModule", { value: true });
var radii = {
    "circle": "100px",
    "badges": "22px",
    "rounded": "4px",
    "hard": "0px",
    "card": "12px",
    "field": "8px",
};
exports.default = radii;
//# sourceMappingURL=radii.js.map